var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg25Dumbbells(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1290.24 845.652L1280.13 851.206L1283.78 845.163L1293.9 839.57L1290.24 845.652ZM1288.86 873.041L1285.71 878.176L1285.17 879.084L1275.06 884.638L1278.76 878.595L1288.86 873.041ZM1307.23 866.425L1310.89 860.382L1321 854.828L1317.35 860.871L1307.23 866.425ZM1258.38 863.446L1258.11 863.865L1248 869.419L1251.65 863.376L1261.76 857.822L1258.38 863.446Z",
    fill: "#8872B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.06 875.717L1264.11 870.28L1267.76 864.198L1275.06 868.356L1278.76 878.595L1275.06 884.638L1274.67 884.413L1267.75 880.488L1266.06 875.717ZM1297.04 854.301L1296.24 852.074L1299.89 845.993L1307.23 850.151L1310.89 860.39L1307.23 866.432L1306.97 866.246L1301.85 863.415L1307.12 860.467C1307.42 860.041 1307.57 859.451 1307.57 858.691C1307.57 857.907 1307.41 857.101 1307.08 856.271C1306.91 855.875 1306.71 855.472 1306.46 855.061C1305.69 853.804 1304.78 852.873 1303.73 852.268C1302.93 851.818 1302.21 851.64 1301.57 851.741L1297.04 854.301ZM1280.13 834.924L1283.78 845.163L1280.13 851.206L1274.79 848.149L1280.01 845.241C1280.34 844.791 1280.51 844.186 1280.51 843.425C1280.51 842.72 1280.37 842.006 1280.08 841.269C1279.89 840.796 1279.66 840.315 1279.35 839.834C1278.61 838.577 1277.7 837.647 1276.62 837.041C1275.82 836.592 1275.12 836.413 1274.5 836.514L1269.92 839.082L1269.12 836.817L1272.77 830.774L1280.13 834.924ZM1240.65 865.253L1239.08 860.793L1237 855.053L1240.65 848.972L1248 853.129L1251.65 863.368L1248 869.411L1247.88 869.333L1240.65 865.253Z",
    fill: "#6D5996"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.86 873.041L1278.75 878.595L1275.05 868.356L1285.16 862.802L1288.16 871.11L1288.86 873.041ZM1319.65 851.051L1320.99 854.828L1310.88 860.382L1307.23 850.143L1317.34 844.589L1319.65 851.051ZM1283.78 845.163L1280.13 834.924L1290.24 829.37L1292.62 835.979L1293.89 839.57L1283.78 845.163ZM1251.65 863.369L1248 853.129L1258.11 847.576L1261.07 855.883L1261.76 857.807L1251.65 863.369Z",
    fill: "#9B85CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.86 858.645L1283.55 861.895L1285.17 862.802L1275.06 868.356L1267.76 864.198L1277.86 858.645ZM1305.27 843.045L1310 840.439L1317.34 844.597L1307.23 850.151L1299.89 845.993L1305.27 843.045ZM1278.09 827.857L1282.94 825.212L1290.24 829.37L1280.13 834.924L1272.79 830.766L1278.09 827.857ZM1240.66 848.972L1250.77 843.418L1256.5 846.668L1258.11 847.575L1248 853.129L1240.66 848.972Z",
    fill: "#AE9AD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.58 851.733C1302.22 851.633 1302.94 851.811 1303.74 852.261C1304.79 852.866 1305.7 853.797 1306.47 855.053C1306.72 855.464 1306.92 855.868 1307.09 856.263C1307.42 857.093 1307.58 857.9 1307.58 858.684C1307.58 859.436 1307.43 860.033 1307.13 860.46L1301.86 863.408L1288.17 871.11L1285.17 862.802L1283.56 861.895L1297.05 854.301L1301.58 851.733Z",
    fill: "url(#paint0_linear_1949_30020)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.11 847.575L1256.49 846.668L1269.95 839.074L1274.53 836.506C1275.14 836.406 1275.84 836.584 1276.64 837.034C1277.71 837.639 1278.63 838.57 1279.37 839.826C1279.67 840.307 1279.92 840.788 1280.11 841.261C1280.39 841.99 1280.53 842.712 1280.53 843.418C1280.53 844.17 1280.37 844.775 1280.03 845.233L1274.81 848.142L1261.08 855.883L1258.11 847.575Z",
    fill: "url(#paint1_linear_1949_30020)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1949_30020)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 705.154,
    y: 213.267,
    width: 65.9128,
    height: 60.7767,
    transform: "rotate(0.650738 705.154 213.267)",
    fill: "url(#paint2_linear_1949_30020)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M722.979 213.476L705.003 213.476L705.003 234.453L722.979 213.476Z",
    fill: "url(#paint3_linear_1949_30020)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1949_30020)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 737.959,
    cy: 213.909,
    r: 2.56803,
    fill: "#F34B88"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 737.959,
    cy: 213.909,
    r: 1.71202,
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M741.757 243.371L740.725 241.586C740.501 241.198 740.179 240.877 739.792 240.653C739.404 240.429 738.964 240.312 738.516 240.312H736.454C735.868 240.312 735.3 240.514 734.846 240.884L733.736 241.518L734.131 241.782L733.213 243.369C732.989 243.757 732.872 244.196 732.872 244.643C732.872 245.091 732.989 245.53 733.213 245.917L734.245 247.703C734.469 248.09 734.791 248.412 735.178 248.635C735.566 248.859 736.006 248.977 736.454 248.977H738.294L738.358 249.488L739.778 248.643C740.172 248.42 740.499 248.095 740.725 247.703L741.757 245.918C741.981 245.531 742.098 245.092 742.098 244.644C742.098 244.197 741.981 243.758 741.757 243.371Z",
    fill: "#E3A5D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M732.922 248.497L731.891 246.713C731.667 246.325 731.549 245.886 731.549 245.439C731.549 244.991 731.667 244.552 731.891 244.165L732.922 242.379C733.146 241.992 733.468 241.67 733.856 241.447C734.244 241.223 734.683 241.105 735.131 241.105H737.194C737.642 241.105 738.082 241.223 738.47 241.447C738.857 241.67 739.179 241.992 739.403 242.379L740.434 244.165C740.658 244.552 740.776 244.991 740.776 245.439C740.776 245.886 740.658 246.325 740.434 246.713L739.403 248.497C739.179 248.885 738.857 249.206 738.47 249.43C738.082 249.654 737.642 249.772 737.194 249.772H735.131C734.683 249.772 734.243 249.654 733.856 249.43C733.468 249.206 733.146 248.885 732.922 248.497Z",
    fill: "#CF4D7B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M729.716 251.099C729.312 251.1 728.919 250.968 728.596 250.725C728.274 250.482 728.04 250.139 727.93 249.751C727.821 249.362 727.842 248.948 727.99 248.572C728.138 248.197 728.405 247.88 728.751 247.67L734.671 244.063C735.091 243.807 735.595 243.729 736.072 243.845C736.309 243.902 736.531 244.005 736.728 244.149C736.924 244.292 737.091 244.473 737.217 244.68C737.344 244.888 737.428 245.118 737.466 245.358C737.503 245.599 737.493 245.844 737.435 246.08C737.378 246.316 737.275 246.539 737.131 246.735C736.988 246.931 736.807 247.097 736.599 247.224L730.678 250.831C730.388 251.007 730.055 251.099 729.716 251.099Z",
    fill: "url(#paint4_linear_1949_30020)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M731.209 249.712L730.177 247.927C729.953 247.54 729.631 247.218 729.243 246.995C728.855 246.771 728.415 246.653 727.968 246.653H725.905C725.319 246.654 724.751 246.855 724.297 247.225L723.187 247.861L723.581 248.125L722.664 249.712C722.441 250.099 722.323 250.539 722.323 250.986C722.323 251.433 722.441 251.873 722.664 252.26L723.696 254.044C723.92 254.431 724.242 254.753 724.63 254.977C725.017 255.2 725.457 255.318 725.905 255.318H727.747L727.811 255.83L729.231 254.984C729.624 254.761 729.951 254.436 730.177 254.044L731.209 252.26C731.433 251.873 731.551 251.433 731.551 250.986C731.551 250.539 731.433 250.099 731.209 249.712Z",
    fill: "#A8AD3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M722.373 254.838L721.342 253.052C721.118 252.665 721 252.226 721 251.778C721 251.331 721.118 250.892 721.342 250.504L722.373 248.72C722.597 248.332 722.919 248.011 723.307 247.787C723.694 247.563 724.134 247.445 724.582 247.445H726.645C727.093 247.445 727.532 247.563 727.92 247.787C728.308 248.011 728.63 248.332 728.854 248.72L729.885 250.504C730.109 250.892 730.227 251.331 730.227 251.778C730.227 252.226 730.109 252.665 729.885 253.052L728.854 254.838C728.63 255.225 728.308 255.547 727.92 255.77C727.532 255.994 727.093 256.112 726.645 256.112H724.582C724.134 256.112 723.695 255.994 723.307 255.77C722.919 255.547 722.597 255.225 722.373 254.838Z",
    fill: "#BBC64F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M731.209 249.712L730.177 247.927C729.953 247.54 729.631 247.218 729.243 246.995C728.855 246.771 728.415 246.653 727.968 246.653H725.905C725.319 246.654 724.751 246.855 724.297 247.225L723.187 247.861L723.581 248.125L722.664 249.712C722.441 250.099 722.323 250.539 722.323 250.986C722.323 251.433 722.441 251.873 722.664 252.26L723.696 254.044C723.92 254.431 724.242 254.753 724.63 254.977C725.017 255.2 725.457 255.318 725.905 255.318H727.747L727.811 255.83L729.231 254.984C729.624 254.761 729.951 254.436 730.177 254.044L731.209 252.26C731.433 251.873 731.551 251.433 731.551 250.986C731.551 250.539 731.433 250.099 731.209 249.712Z",
    fill: "#CF4D7B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M722.373 254.838L721.342 253.052C721.118 252.665 721 252.226 721 251.778C721 251.331 721.118 250.892 721.342 250.504L722.373 248.72C722.597 248.332 722.919 248.011 723.307 247.787C723.694 247.563 724.134 247.445 724.582 247.445H726.645C727.093 247.445 727.532 247.563 727.92 247.787C728.308 248.011 728.63 248.332 728.854 248.72L729.885 250.504C730.109 250.892 730.227 251.331 730.227 251.778C730.227 252.226 730.109 252.665 729.885 253.052L728.854 254.838C728.63 255.225 728.308 255.547 727.92 255.77C727.532 255.994 727.093 256.112 726.645 256.112H724.582C724.134 256.112 723.695 255.994 723.307 255.77C722.919 255.547 722.597 255.225 722.373 254.838Z",
    fill: "#EA7FA4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M732.629 240.475C732.663 240.381 732.706 240.289 732.755 240.201C732.875 239.99 733.035 239.804 733.227 239.654C733.419 239.505 733.638 239.394 733.872 239.33C734.346 239.198 734.852 239.26 735.279 239.502L746.491 245.845C746.847 246.046 747.127 246.359 747.286 246.736C747.445 247.113 747.475 247.532 747.371 247.927C747.266 248.323 747.034 248.672 746.709 248.922C746.406 249.155 746.038 249.288 745.656 249.303C745.621 249.305 745.585 249.305 745.55 249.304C745.239 249.301 744.935 249.219 744.664 249.066L734.17 243.127L733.456 242.723C733.048 242.493 732.742 242.117 732.601 241.67C732.477 241.278 732.488 240.858 732.629 240.475Z",
    fill: "url(#paint5_linear_1949_30020)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.507 239.158L732.644 235.222C733.381 233.814 737.683 236.065 736.945 237.472L734.815 241.396L730.507 239.158ZM732.935 244.858C732.2 246.266 727.898 244.015 728.636 242.608L730.508 239.159L734.813 241.399L732.935 244.858Z",
    fill: "url(#paint6_linear_1949_30020)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M745.296 247.225L747.433 243.289C748.171 241.881 752.472 244.131 751.735 245.538L749.605 249.464L745.296 247.225ZM747.724 252.924C746.989 254.332 742.688 252.082 743.426 250.674L745.294 247.226L749.602 249.465L747.724 252.924Z",
    fill: "url(#paint7_linear_1949_30020)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1949_30020",
    x: 696.464,
    y: 211.267,
    width: 82.5988,
    height: 77.5215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1949_30020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1949_30020",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1949_30020",
    x: 733.391,
    y: 210.341,
    width: 9.13605,
    height: 9.13623,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.18625 0 0 0 0 0.44755 0 0 0 0 0.620833 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1949_30020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1949_30020",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1949_30020",
    x1: 1293.88,
    y1: 857.236,
    x2: 1299.65,
    y2: 867.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4D9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1949_30020",
    x1: 1267.33,
    y1: 842.9,
    x2: 1272.79,
    y2: 852.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4D9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1949_30020",
    x1: 738.11,
    y1: 213.267,
    x2: 738.11,
    y2: 274.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1949_30020",
    x1: 704.183,
    y1: 215.722,
    x2: 714.219,
    y2: 224.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD29A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEECA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1949_30020",
    x1: 734.825,
    y1: 244.026,
    x2: 732.678,
    y2: 251.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2809C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0527B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1949_30020",
    x1: 741.306,
    y1: 242.299,
    x2: 739.149,
    y2: 246.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8DA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D85474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1949_30020",
    x1: 732.791,
    y1: 234.776,
    x2: 729.215,
    y2: 244.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1949_30020",
    x1: 749.947,
    y1: 243.163,
    x2: 744.338,
    y2: 252.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE496D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg25Dumbbells);
export default __webpack_public_path__ + "static/media/25Dumbbells.7da5787d4d71f942839853d505be67ea.svg";
export { ForwardRef as ReactComponent };